export default __webpack_public_path__ + "static/media/404.27e787ee.svg";